import {mutations} from "@/modules/Chat/store/mutations";
import {actions} from "@/modules/Chat/store/actions";
import {getters} from "@/modules/Chat/store/getters";

const state = {

    // Team chat
    teamMessages: [],
    chatUsers: [],

    // Private chat
    privateMessages: {},
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

